export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#004E89] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h60v60H0z' fill='none'/%3E%3Cpath d='M30 0v60M0 30h60' stroke='%23ffffff' stroke-width='0.5'/%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-20 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-serif mb-4">
              David Nieves Art<span className="text-[#e8a65b]">.</span>
            </h3>
            <p className="text-white/80 text-sm mb-6 leading-relaxed">
              Recibe actualizaciones exclusivas de nuevas obras y exposiciones directamente en tu correo.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Tu correo electrónico"
                className="flex-1 px-4 py-3 bg-transparent border border-white/30 rounded-lg text-white placeholder-white/50 text-sm focus:outline-none focus:border-[#e8a65b] transition-colors"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-[#e8a65b] rounded-lg hover:bg-[#d99549] transition-colors cursor-pointer">
                <i className="ri-mail-line text-white text-lg"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider">Galería</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Obras Destacadas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Colección Completa
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('shop')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Nuevas Obras
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider">Tienda</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('shop')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Comprar Arte
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('shop')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Obras Disponibles
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Encargos
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-wider">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Sobre el Artista
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Contactar
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('instagram')} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  Redes Sociales
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-white/60 text-sm">
            © 2025 David Nieves Art Gallery. Todos los derechos reservados.
          </p>

          <div className="flex items-center gap-4">
            <a 
              href="https://www.instagram.com/davidnievesart/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-[#e8a65b] hover:bg-[#e8a65b]/10 transition-all cursor-pointer"
            >
              <i className="ri-instagram-line text-white text-lg"></i>
            </a>
            <a 
              href="https://www.facebook.com/davidnievesart" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-[#e8a65b] hover:bg-[#e8a65b]/10 transition-all cursor-pointer"
            >
              <i className="ri-facebook-fill text-white text-lg"></i>
            </a>
            <a 
              href="https://www.pinterest.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-[#e8a65b] hover:bg-[#e8a65b]/10 transition-all cursor-pointer"
            >
              <i className="ri-pinterest-fill text-white text-lg"></i>
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-[#e8a65b] hover:bg-[#e8a65b]/10 transition-all cursor-pointer"
            >
              <i className="ri-mail-line text-white text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}